"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EOMONTH = void 0;
const common_1 = require("@finley-technologies/common");
exports.EOMONTH = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 2, max: 2 },
    },
    evaluate: (inputs) => {
        const [dateValue, offset] = inputs;
        if (typeof dateValue !== 'string' ||
            !common_1.typeguards.isISO8601Date(dateValue)) {
            return {
                error: 'Invalid date',
            };
        }
        if (typeof offset !== 'number') {
            return {
                error: 'Invalid month offset',
            };
        }
        const date = new Date(dateValue);
        date.setUTCHours(0, 0, 0);
        // Update to first of month
        date.setUTCDate(1);
        // For given offset, add offset + 1 months, then roll back 1 day by setting date to 0
        const newMonth = date.getUTCMonth() + offset + 1;
        date.setUTCMonth(newMonth);
        date.setUTCDate(0);
        const endOfMonth = date.toISOString().slice(0, 10);
        if (!common_1.typeguards.isISO8601Date(endOfMonth)) {
            return { error: 'Error retrieving end of month value' };
        }
        return { error: null, result: endOfMonth };
    },
};
//# sourceMappingURL=eomonth.js.map